<!-- =========================================================================================
    File Name: MailItem.vue
    Description: Mail Item - Displays mail item
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div class="mail__mail-item sm:px-4 px-2 py-6">

        <!-- MAIL ROW 1 : META -->
        <div class="flex w-full">
            <!-- <vs-avatar class="sender__avatar flex-shrink-0 mr-3 border-2 border-solid border-white" :src="mail.img" size="40px"></vs-avatar> -->
            <!-- <vs-avatar class="sender__avatar flex-shrink-0 mr-3 border-2 border-white" src="@/assets/images/portrait/small/avatar-s-11.jpg"  size="40px"></vs-avatar> -->
            <img key="onlineImg" :src="photoURL" alt="user-img" width="40" height="40" class="sender__avatar flex-shrink-0 mr-3 border-2 border-white rounded-full shadow-md cursor-pointer block" />

            <div class="flex w-full justify-between items-start ">
                <div class="mail__details">
                    <!-- <h5 class="mb-1" :class="{'font-semibold': mail.unread}">{{ notice.name }}</h5> -->
                    <h5 class="mb-1" :class="{'font-semibold': true}">{{ onlineTest.name }}</h5>
                    <span>{{ onlineTest.title }}</span>
                </div>
                <div class="mail-item__meta flex items-center">
                  <vs-chip v-if="onlineTest.state_val == -99" color="#d5d5d5" style="margin-right:10px;">종료</vs-chip>
                  <vs-chip v-if="onlineTest.state_val != -99 && onlineTest.state_val < 0 " color="warning" style="margin-right:10px;">{{onlineTest.state_val*-1}}H</vs-chip>
                  <vs-chip v-if="onlineTest.state_val == 0" color="danger" style="margin-right:10px;">시험중</vs-chip>
                  <vs-chip v-if="onlineTest.state_val > 0" color="success" style="margin-right:10px;">D-{{onlineTest.state_val}}</vs-chip>
                  <span style="width:50px;">{{ onlineTest.start_time | onlydate }}</span>
                  <span style="width:80px;">{{ onlineTest.start_time | time }}</span>
                </div>
            </div>
        </div>
        <!-- /MAIL ROW 1 -->

        <!-- MAIL ROW 2 : MSG & ACTIONS -->
        <div class="flex w-full">
            <div class="flex items-center ml-1">
                <!-- <vs-checkbox v-model="isSelectedMail" @click.stop class="vs-checkbox-small ml-0 mr-1"></vs-checkbox> -->
                <!-- <feather-icon icon="StarIcon" class="cursor-pointer" :svgClasses="[{'text-warning fill-current stroke-current': mail.isStarred}, 'w-5', 'h-5']" @click.stop="toggleIsStarred"></feather-icon> -->
            </div>
            <!-- <div class="mail__message truncate ml-3">
                <span>{{ notice.detail | filter_tags }}</span>
            </div> -->
        </div>
        <!-- /MAIL ROW 2 -->
    </div>
</template>

<script>
export default {
  props: ['onlineTest'],
  selected: [],
  data() {
    return {
      photoURL:require("@/assets/images/portrait/small/" + this.onlineTest['photo_url'])
    }
  },
  // data() {
  //   return {
  //     isSelectedMail: this.isSelected,
  //   }
  // },
  // watch: {
  //   isSelected(value) {
  //     this.isSelectedMail = value
  //   },
  //   isSelectedMail(val) {
  //     val ? this.$emit('addToSelected', this.mail.id) : this.$emit('removeSelected', this.mail.id)
  //   }
  // },
  // computed: {
  //   labelColor() {
  //     return (label) => {
  //       const tags = this.$store.state.email.mailTags
  //       return tags.find((tag) => {
  //         return tag.value == label
  //       }).color
  //     }
  //   },
  // },
  // methods: {
  //   toggleIsStarred() {
  //     const payload = { mailId: this.mail.id, value: !this.mail.isStarred }
  //     this.$store.dispatch('email/toggleIsMailStarred', payload)
  //   }
  // }

}

</script>
